import { fork, call, put, take, select } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get vessels
 * */
function* getVessels(pagination) {
    const store = yield select();
    const response = yield call(api.getVessels, {
        ...store.vessels,
        ...pagination,
    });

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_VESSELS.SUCCESS,
            data: response,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_VESSELS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetVessels() {
    while (true) {
        const { pagination } = yield take(actionTypes.GET_VESSELS.REQUEST);
        yield fork(getVessels, pagination);
    }
}

function* getVessel(id) {
    const response = yield call(api.getVessel, id);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_VESSEL.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_VESSEL.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetVessel() {
    while (true) {
        const { id } = yield take(actionTypes.GET_VESSEL.REQUEST);
        yield fork(getVessel, id);
    }
}

function* confirmVessel(id) {
    const response = yield call(api.confirmVessel, id);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield put({
            type: actionTypes.CONFIRM_VESSEL.SUCCESS,
            data: response.data.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.CONFIRM_VESSEL.FAILURE,
    });

    return response;
}

export function* watchConfirmVessel() {
    while (true) {
        const { id } = yield take(actionTypes.CONFIRM_VESSEL.REQUEST);
        yield fork(confirmVessel, id);
    }
}

function* deleteNameSuggestion({ vessel, refreshVessel, suggestedName }) {
    const response = yield call(api.deleteNameSuggestion, { vessel, suggestedName });

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,

            notification: {
                title: 'Vessel\'s name suggestion\'s been successfully removed!',

                message: response.data.message,

                level: 'success',

                _id: new Date().getMilliseconds(),

                autoDismiss: 10,
            },
        });

        yield put({
            type: actionTypes.DELETE_NAME_SUGGESTION.SUCCESS,

            data: vessel,
        });

        if (typeof refreshVessel === 'function') {
            refreshVessel();
        }

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,

        notification: {
            title: response.errors[0].messages
                ? response.errors[0].field
                : 'error',

            message: response.errors[0].messages
                ? response.errors[0].messages[0]
                : response.errors[0].message,

            level: 'error',

            _id: new Date().getMilliseconds(),

            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.DELETE_NAME_SUGGESTION.FAILURE,

        errors: response.errors,

        vessel,
    });

    if (typeof refreshVessel === 'function') {
        refreshVessel();
    }

    return response;
}

function* renameVessel(vessel, refreshVessel) {
    const response = yield call(api.renameVessel, vessel);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,

            notification: {
                title: 'Vessel\'s been successfully renamed!',

                message: response.data.message,

                level: 'success',

                _id: new Date().getMilliseconds(),

                autoDismiss: 10,
            },
        });

        yield put({
            type: actionTypes.RENAME_VESSEL.SUCCESS,

            data: vessel,
        });

        if (typeof refreshVessel === 'function') {
            refreshVessel();
        }

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,

        notification: {
            title: response.errors[0].messages
                ? response.errors[0].field
                : 'error',

            message: response.errors[0].messages
                ? response.errors[0].messages[0]
                : response.errors[0].message,

            level: 'error',

            _id: new Date().getMilliseconds(),

            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.RENAME_VESSEL.FAILURE,

        errors: response.errors,

        vessel,
    });

    if (typeof refreshVessel === 'function') {
        refreshVessel();
    }

    return response;
}

function* updateVessel(vessel) {
    const response = yield call(api.updateVessel, vessel);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield put({
            type: actionTypes.UPDATE_VESSEL.SUCCESS,
            data: vessel,
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: response.errors[0] && response.errors[0].messages
                ? response.errors[0].field
                : 'error',
            message: response.errors[0] && response.errors[0].messages
                ? response.errors[0].messages[0]
                : (response.errors[0] && response.errors[0].message) || response.message,
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.UPDATE_VESSEL.FAILURE,
        errors: response.errors,
        vessel,
    });

    return response;
}

export function* watchDeleteNameSuggestion() {
    while (true) {
        const { vessel, refreshVessel, suggestedName } = yield take(actionTypes.DELETE_NAME_SUGGESTION.REQUEST);

        yield fork(deleteNameSuggestion, { vessel, refreshVessel, suggestedName });
    }
}

export function* watchRenameVessel() {
    while (true) {
        const { vessel, refreshVessel } = yield take(actionTypes.RENAME_VESSEL.REQUEST);

        yield fork(renameVessel, vessel, refreshVessel);
    }
}

export function* watchUpdateVessel() {
    while (true) {
        const { vessel } = yield take(actionTypes.UPDATE_VESSEL.REQUEST);
        yield fork(updateVessel, vessel);
    }
}

function* deleteVessel(vessel, reason) {
    const response = yield call(api.deleteVessel, vessel, reason);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.messages,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield put({
            type: actionTypes.DELETE_VESSEL.SUCCESS,
            data: vessel,
        });

        browserHistory.push('/vessels/list');

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.DELETE_VESSEL.FAILURE,
        errors: response.errors,
        vessel,
    });

    return response;
}

export function* watchDeleteVessel() {
    while (true) {
        const { vessel, reason } = yield take(actionTypes.DELETE_VESSEL.REQUEST);
        yield fork(deleteVessel, vessel, reason);
    }
}

function* addVessel(vessel) {
    const response = yield call(api.addVessel, vessel);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.messages,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield put({
            type: actionTypes.ADD_VESSEL.SUCCESS,
            data: vessel,
        });

        browserHistory.push('/vessels/list');

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: response.errors[0].messages
                ? response.errors[0].field
                : 'error',
            message: response.errors[0].messages
                ? response.errors[0].messages[0]
                : response.errors[0].message,
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.ADD_VESSEL.FAILURE,
        errors: response.errors,
        vessel,
    });

    return response;
}

export function* watchAddVessel() {
    while (true) {
        const { vessel } = yield take(actionTypes.ADD_VESSEL.REQUEST);
        yield fork(addVessel, vessel);
    }
}

function* updateVesselImage(vesselId, images) {
    const response = yield call(api.updateVesselImage, vesselId, images);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Vessel image updated successfully',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield put({
            type: actionTypes.UPDATE_VESSEL_IMAGE.SUCCESS,
            data: images,
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: response.errors[0].messages
                ? response.errors[0].field
                : 'error',
            message: response.errors[0].messages
                ? response.errors[0].messages[0]
                : response.errors[0].message,
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.UPDATE_VESSEL_IMAGE.FAILURE,
        errors: response.errors,
        images,
    });

    return response;
}

export function* watchUpdateVesselImage() {
    while (true) {
        const { vesselId, images } = yield take(actionTypes.UPDATE_VESSEL_IMAGE.REQUEST);
        yield fork(updateVesselImage, vesselId, images);
    }
}

function* patchVesselFields(vesselId, fields) {
    const response = yield call(api.patchVesselFields, vesselId, fields);

    if (response.status === 200 || response.success) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Vessel fields updated successfully',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield put({
            type: actionTypes.PATCH_VESSEL_FIELDS.SUCCESS,
            vesselId,
            fields,
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: response.errors && response.errors[0] && response.errors[0].messages
                ? response.errors[0].field
                : 'error',
            message: response.errors && response.errors[0] && response.errors[0].messages
                ? response.errors[0].messages[0]
                : (response.errors && response.errors[0] && response.errors[0].message) || response.message || 'Update failed',
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.PATCH_VESSEL_FIELDS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchPatchVesselFields() {
    while (true) {
        const { vesselId, fields } = yield take(actionTypes.PATCH_VESSEL_FIELDS.REQUEST);
        yield fork(patchVesselFields, vesselId, fields);
    }
}

export default [
    watchGetVessels,
    watchGetVessel,
    watchDeleteNameSuggestion,
    watchRenameVessel,
    watchUpdateVessel,
    watchDeleteVessel,
    watchAddVessel,
    watchConfirmVessel,
    watchUpdateVesselImage,
    watchPatchVesselFields,
];



// WEBPACK FOOTER //
// ./app/sagas/vessels/vessels.js